import * as Yup from 'yup';
import { Button, Row, Col } from 'react-bootstrap';
import { useAPI } from '../services/api';
import { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Formik, Form } from 'formik';
import * as valid from '../services/validation';
import ValidationInput from '../components/ValidationTextInput';
import ValidationRadioGroup from './ValidationRadioGroup';
import EditAddress from './EditAddress';
import ToastContext from '../store/toast-context';
import formatPhoneNumber, { deformatPhoneNumber } from '../services/formatPhoneNumber';
import '../styles/components/custom-buttons.scss';

const dataSchema = Yup.object().shape({
  companyName: valid.companyNameValidation(),
  username: valid.usernameValidation(),
  phoneNumber: valid.phoneValidation(),
  email: valid.emailValidation(),
  password: valid.passwordValidation(),
  confirmPassword: valid.confirmPasswordValidation(),
  address: valid.stringValidation(),
  city: valid.cityValidation(),
  state: valid.stringValidation(),
  zip: valid.zipValidation(),
  userType: valid.stringValidation(),
});

const initialValues = {
  companyName: '',
  username: '',
  phoneNumber: '',
  email: '',
  password: '',
  confirmPassword: '',
  address: '',
  city: '',
  zip: '',
  state: '',
  userType: '',
};

const RegistrationForm = () => {
  const api = useAPI();
  const { success, error } = useContext(ToastContext);
  const history = useHistory();

  const submitClicked = async (values) => {
    for (const key in values) {
      values[key] = values[key].trim();
    }
    values.phoneNumber = deformatPhoneNumber(values.phoneNumber);
    try {
      await api.post(`/users/register`, values);
      success('Successfully Registered!');
      history.push('/');
    } catch (e) {
      error(e.response.data);
    }
  };

  return (
    <Formik onSubmit={submitClicked} initialValues={initialValues} validationSchema={dataSchema}>
      {({ setFieldValue }) => (
        <Form className="p-4">
          <Row>
            <ValidationInput name="companyName" label="" placeholder="Company Name" />
          </Row>
          <Row>
            <ValidationInput name="username" label="" placeholder="Username" />
          </Row>
          <Row>
            <Col xs={12} md={6}>
              <Row>
                <ValidationInput
                  onChange={(value) => setFieldValue('phoneNumber', formatPhoneNumber(value))}
                  name="phoneNumber"
                  label=""
                  placeholder="Phone Number"
                />
              </Row>
              <Row>
                <Col>
                  <EditAddress />
                </Col>
              </Row>
            </Col>
            <Col xs={12} md={6}>
              <Row>
                <ValidationInput name="email" label="" placeholder="Email" />
              </Row>
              <Row>
                <Col>
                  <ValidationInput name="password" label="" placeholder="Password" password />
                  <ValidationInput
                    name="confirmPassword"
                    label=""
                    placeholder="Confirm Password"
                    password
                  />
                  <ValidationRadioGroup
                    name="userType"
                    labels={['Tax Service', 'Mortgage Company']}
                    values={['S', 'M']}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={{ span: 5, offset: 7 }}>
              <Button type="submit" size="lg" className="mt-3 w-100 dark-btn">
                Register
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );
};

export default RegistrationForm;
